import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconChevronDown = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M3.55 18.31c-.63.08-1.197.515-1.492 1.146-.131.279-.166.452-.167.832-.002.905-1.145-.304 14.091 14.918 12.892 12.88 13.774 13.748 14.2 13.966.626.32 1.099.433 1.818.433s1.193-.113 1.818-.433c.426-.218 1.308-1.085 14.2-13.966C59.66 23.575 61.791 21.418 61.938 21.12c.353-.72.181-1.674-.41-2.265-.382-.383-.82-.558-1.393-.558-.956 0 .381-1.256-14.647 13.76L32 45.535l-13.456-13.45C8.82 22.368 5.009 18.598 4.804 18.496c-.34-.17-.818-.24-1.253-.185" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconChevronDown.displayName = 'IconChevronDown';